/* Program Name: AttributeEyeCon.js
 **  Description: pre-styled Privacy Icon with Tool Tip
 **
 **
 ** Project    Date        Who  Comments
 ** ---------  ----------  ---  ---------------------------------------------------
 ** IS0200243  2024-04-01  STT  Initial program
 *********************************************************************************/

import { VisibilityOff } from '@mui/icons-material'
import { Tooltip } from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types'

const AttributeEyeCon = ({ message }) => {
  /****************************************************************************/
  /**Render*/

  return (
    <>
      <Tooltip title={message}>
        <VisibilityOff size="small" fontSize="10" />
      </Tooltip>
    </>
  )
}

AttributeEyeCon.propTypes = {
  message: PropTypes.string,
}

AttributeEyeCon.defaultProps = {
  message: 'This is not visible by Shop Users',
}

export default AttributeEyeCon
